var React = require('react');

function AwsAccountStatistics (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"8","fill":"#064861","key":0}),React.createElement("mask",{"id":"mask0_5595_2229","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"12","y":"12","width":"24","height":"24","key":1},React.createElement("rect",{"x":"12","y":"12","width":"24","height":"24","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5595_2229)","key":2},React.createElement("path",{"d":"M28 32V25H32V32H28ZM22 32V16H26V32H22ZM16 32V21H20V32H16Z","fill":"#FFD301"}))]);
}

AwsAccountStatistics.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = AwsAccountStatistics;

AwsAccountStatistics.default = AwsAccountStatistics;
